import Vue from 'vue';
import VueRouter from 'vue-router';
import HomeView from '../views/HomeView.vue';
import IndexView from "@/views/IndexView";

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'index',
    component: IndexView,
  },
  {

    path: '/app',
    name: 'home',
    component: HomeView,
  },
  {
    path: '/meme',
    name: 'meme',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/MemeView.vue'),
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

export default router;
